import type { ReactNode } from 'react';

export const symbol_chess_queen: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M276-120q-21.85 0-38.42-13.5Q221-147 217-169l-81-449q-35 13-65.5-8T40-685q0-29.7 20.8-50.85Q81.59-757 110.8-757q29.2 0 50.2 21.15 21 21.15 21 50.85 0 15.11-5.5 28.05Q171-644 161-634q26.21 17.33 53.01 28.67Q240.81-594 270.59-594 323-594 365-624t68-76l23-42q-21-8-34-26t-13-41q0-29.29 20.8-50.14 20.79-20.86 50-20.86 29.2 0 50.2 20.86 21 20.85 21 50.14 0 23-13 41t-34 26l23 42q26 46 68.5 76t94.99 30q29.83 0 56.67-11.5Q774-617 800-633q-11-10-16.5-23.46T778-685q0-29.7 20.8-50.85 20.79-21.15 50-21.15 29.2 0 50.2 21.15 21 21.15 21 50.85 0 37-29.5 58T827-617l-83 448q-4 21-20.58 35-16.57 14-38.42 14H276Zm0-60h408l66-361q-15 3-30 5.5t-30 2.5q-66 0-120.5-35T480-660q-35 56-89 91.5T271-533q-16 0-31-2.5t-30-4.5l66 360Zm204 0Z"
		/>
	</svg>
);
